<template>
  <v-container class="py-3 pl-4 aboutus-listing-container">
    <v-list>
      <v-list-item-group>
        <div v-for="(item, index) in items" :key="item.id">
          <v-list-item class="pl-2 pr-1" @click="handleItemClick(item)">
            <v-list-item-content>
              <v-list-item-title
                v-text="item.title"
                class="text-wrap"
              ></v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon
                v-if="selected && item.id === selected.id"
                size="14"
                color="green"
                >fas fa-star</v-icon
              >
            </v-list-item-icon>
          </v-list-item>
          <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
        </div>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";

import { GRD_ABOUT_US } from "@/common/constants/grd";

const EMITTED_ACTIONS = {
  SELECTED: "selected",
};

export default {
  name: "AboutUs",
  data: function () {
    let items = GRD_ABOUT_US;
    items = lodashOrderBy(items, ["order"], ["asc"]);
    return {
      items: items,
      selected: null,
    };
  },
  mounted() {
    this.handleItemClick(this.items[0]);
  },
  methods: {
    handleItemClick(item) {
      this.selected = item;
      this.$emit(EMITTED_ACTIONS.SELECTED, item);
    },
  },
};
</script>

<style scoped>
.aboutus-listing-container {
  height: 87vh;
  overflow-y: auto;
}
/* These are for the scroll bar in the container */
::-webkit-scrollbar {
  width: 8px;
  height: 3px;
}
.dark::-webkit-scrollbar-track {
  background-color: red; /* #646464; */
  border-radius: 3px;
}
.dark::-webkit-scrollbar-track-piece {
  background-color: #000;
}
.dark::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #666;
  border-radius: 3px;
}
.dark::-webkit-scrollbar-thumb:hover {
  background: black;
}
.light::-webkit-scrollbar-track {
  background-color: #e6e6e6;
  border-radius: 3px;
}
.light::-webkit-scrollbar-track-piece {
  background-color: #e6e6e6;
}
.light::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #b0b0b0;
  border-radius: 3px;
}
.light::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>
